<template>
    <div class="scene-main">
        <div class="left-top">
            <img src="/images/game/logo.png"/>
        </div>
        <img class="main-top" src="/images/game/main-top.png"/>
        <div class="right-top">
            <div class="checkpoint-list">
                <div
                        class="checkpoint"
                        v-for="(item, index) in checkpoint"
                        :key="item.id"
                        v-show="item.active"
                >
                    <img :src="getCheckpointIcon(index)"/>
                </div>
            </div>
            <img class="background" src="/images/game/head-background.png"/>
            <img class="avatar" :src="util.getImageUrl(user.avatarUrl, '100x100')" v-if="user.avatarUrl"/>
            <div class="avatar" v-else>{{user.name.substring(0, 1)}}</div>
        </div>

        <img class="sprite .hu__hu__" src="/images/game/sprite-2.png"/>

        <div class="dialog">
            <img src="/images/game/dialog.png"/>
        </div>
        <div class="title">
            <img src="/images/game/title.png"/>
        </div>
        <div class="checkpoint-list">
            <div
                    class="checkpoint"
                    :class="(item.active && (item.hover || item.selected)) ? 'hover' : ''"
                    @click="handleCheckpointClick(item)"
                    @dblclick="handleCheckpointDbClick(item)"
                    @mouseover="onMouseOver(item)"
                    @mouseleave="onMouseLeave(item)"
                    v-for="(item, index) in checkpoint"
                    :key="item.id"
            >
                <img class="cover" :src="getCheckpointImg(index)"/>
                <div class="card" v-if="item.card" @click.stop="onCard(item)">兑换礼品卡</div>
                <div class="result" v-if="item.active && item.result">
                    <img :src="`/images/game/${item.result}-result.png`"/>
                </div>
                <div class="tips" v-show="item.hover">
                    支线任务：{{item.desc}}
                    <img src="/images/game/感叹号.png"/>
                    {{item.task ? '已' : '未'}}完成
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="guide-button" @click="handleGuideButton">
                <img src="/images/game/guide-icon.png"/>
                <div>新手指南</div>
            </div>
            <div class="reward-button" @click="handleRewardButton">
                <img src="/images/game/reward-icon.png"/>
                <div>游戏奖励</div>
            </div>
            <div class="ranking-button" @click="handleRankingButton">
                <div class="my-ranking">{{ranking}}</div>
                <div>我的排名</div>
            </div>
            <div class="split"></div>
            <div class="resource" v-for="(item, index) in packageArray" :key="index">
                <img class="image" :src="`/images/game/${item.name}-active.png`" v-if="item.count > 0"/>
                <img class="image" :src="`/images/game/${item.name}-default.png`" v-else/>
                <div class="count">{{item.count}}</div>
            </div>

            <div class="play-button" @click="handlePlayButtonClick">
                <!-- <img src="/images/game/play.png" /> -->
            </div>
        </div>

        <div class="stars"></div>
    </div>
</template>

<script>
    import AudioSwitch from "@/components/game/common/AudioSwitch";

    export default {
        name: "MainScene",
        components: {
            AudioSwitch
        },
        props: {
            resource: {
                type: Array,
                default: function () {
                    return [134, 56, 15, 0, 0, 0, 0];
                }
            }
        },
        computed: {
            user() {
                return this.$store.state.sys.sysUser.me;
            },
            packageArray() {
                const response = this.$store.state.game.common.getMyBackpack;

                return [
                    "赤霞珠",
                    "梅洛",
                    "西拉",
                    "黑皮诺",
                    "霞多丽",
                    "长相思",
                    "雷司令"
                ].map(name => {
                    const r = response.find(e => e.name == name);
                    if (r != null) {
                        return {
                            name,
                            count: r.count
                        };
                    } else {
                        return {
                            name,
                            count: 0
                        };
                    }
                });
            },
            checkpointArray() {
                const response = this.$store.state.game.common.getMyCheckpoint;

                return response.map(e => {
                    return {
                        ...e,
                        hover: false,
                        selected: false
                    };
                });
            }
        },
        data() {
            return {
                ranking: 0,
                selected: 0,
                checkpoint: []
            };
        },
        created() {
            this.init();
        },
        mounted() {
            this.$emit("changeBackgroundMusic", "/music/主背景音乐（场景2、3、4）.mp3");
        },
        methods: {
            async init() {

                let response;

                response = await this.ajax.doPost({
                    packageName: "game",
                    className: "common",
                    methodName: "getMyRanking",
                    params: {}
                });
                this.ranking = response;

                await this.$store.dispatch("post", {
                    packageName: "game",
                    className: "common",
                    methodName: "getMyCheckpoint",
                    params: {}
                });

                await this.$store.dispatch("post", {
                    packageName: "game",
                    className: "common",
                    methodName: "getMyBackpack",
                    params: {}
                });

                this.checkpoint = this.checkpointArray;

                this.checkpoint.map(item => {
                    if (item.active) {
                        this.checkpoint.map(e => (e.selected = false));
                        item.selected = true;
                        this.selected = item.id;
                    }
                });
            },
            getCheckpointImg(index) {
                if (this.checkpoint[index].active) {
                    return `/images/game/cp-${index + 1}-default.png`;
                } else {
                    return `/images/game/cp-${index + 1}-unlock.png`;
                }
            },
            getCheckpointIcon(index) {
                if (this.checkpoint[index].result) {
                    return `/images/game/${this.checkpoint[index].result}.png`;
                } else {
                    return `/images/game/C.png`;
                }
            },
            onCheckpointOver(index, status) {
                console.log(index);
                if (status === "default") {
                    this.checkpoint[index] = "hover";
                }
            },
            onMouseOver(item) {
                console.log(item);
                item.hover = true;
            },
            onMouseLeave(item) {
                item.hover = false;
            },
            onCheckpointLeave(i) {
                console.log(i);
                this.checkpoint[i] = 1;
            },
            onCard(item) {
                console.log(item);
                this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
                this.$store.commit("setTaskStatus", "reward");

                this.ajax.doPost({
                    packageName: "game",
                    className: "common",
                    methodName: "setCardExchange",
                    params: {
                        checkpointId: item.id
                    }
                });
                this.$emit("changeScene", "CheckpointTaskScene");
            },
            handleGuideButton() {
                this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
                this.$emit("changeScene", "GuideScene");
            },
            handleRewardButton() {
                this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
                this.$emit("changeScene", "MyRewardsScene");
            },
            handleRankingButton() {
                this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
                this.$emit("changeScene", "MyRankingScene");
            },
            handleCheckpointClick(item) {
                this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
                if (item.active) {
                    this.checkpoint.map(e => (e.selected = false));
                    item.selected = true;
                    this.selected = item.id;
                }
            },
            handlePlayButtonClick() {
                this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
                this.$store.commit("setCurrentCheckpointId", this.selected);
                this.$emit("changeScene", "CheckpointPlotScene");
            },
            handleCheckpointDbClick(item) {
                this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
                console.log(item);
                if (item.active) {
                    this.$store.commit("setCurrentCheckpointId", item.id);
                    if (this.user.nickName) {
                        this.$emit("changeScene", "CheckpointPlotScene");
                    } else {
                        this.$emit("changeScene", "PlotScene");
                    }
                } else {
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .scene-main {
        width: 1100px;
        height: 560px;
        position: relative;

        background-attachment: fixed;

        @keyframes rotate {
            0% {
                transform: perspective(400px) rotateZ(20deg) rotateX(-40deg) rotateY(0);
            }
            100% {
                transform: perspective(400px) rotateZ(20deg) rotateX(-40deg) rotateY(-360deg);
            }
        }

        .stars {
            transform: perspective(500px);
            transform-style: preserve-3d;
            position: absolute;
            bottom: 0;
            perspective-origin: 50% 100%;
            left: 50%;
            animation: rotate 90s infinite linear;
        }

        .star {
            width: 2px;
            height: 2px;
            background: #f7f7b6;
            position: absolute;
            top: 0;
            left: 0;
            transform-origin: 0 0 -300px;
            transform: translate3d(0, 0, -300px);
            backface-visibility: hidden;
        }

        .main-top {
            position: absolute;
            top: 0px;
            left: 100px;

            width: 650px;
            height: 363px;
        }

        .left-top {
            position: absolute;
            top: 15px;
            left: 15px;

            img {
                width: 111px;
                height: 80px;
            }
        }

        .audio {
            position: absolute;
            top: 100px;
            right: 20px;
            cursor: pointer;
        }

        .sprite {
            position: absolute;
            top: 83px;
            left: 15px;
            width: 409px;
            height: 385px;

            animation: hu__hu__ infinite 2s ease-in-out;
        }

        @keyframes hu__hu__ {
            50% {
                transform: translateY(10px);
            }
        }

        .right-top {
            position: absolute;
            top: 20px;
            right: 20px;
            width: 779px;
            height: 70px;

            .background {
                position: absolute;
                top: 0;
                left: 0;
                width: 779px;
                height: 70px;
            }

            img.avatar {
                position: absolute;
                top: -5px;
                right: -5px;
                width: 60px;
                height: 60px;
            }

            div.avatar {
                position: absolute;
                top: -5px;
                right: -5px;
                width: 60px;
                height: 60px;

                text-align: center;
                line-height: 60px;
                background: #59554D;
                font-size: 30px;
                font-family: 'FZFMJW', serif;
                color: #8D8370;
            }

            .checkpoint-list {
                position: absolute;
                top: 16px;
                right: 60px;
                z-index: 2;

                //   background: rgba(0, 0, 0, 0.1);

                text-align: right;

                .checkpoint {
                    display: inline-block;
                    width: 32px;
                    height: 36px;
                    border: 0;

                    img {
                        width: 32px;
                        height: 36px;
                        //   z-index: 2;
                    }
                }
            }
        }

        .sprite {
            img {
            }
        }

        .dialog {
            position: absolute;
            top: 50px;
            left: 340px;

            img {
                width: 240px;
                height: 76px;
            }
        }

        .title {
            position: absolute;
            top: 70px;
            left: 400px;

            img {
                width: 634px;
                // height: 110px;
            }
        }

        .checkpoint-list {
            position: absolute;
            top: 263px;
            left: 371px;

            .checkpoint {
                position: relative;
                display: inline-block;
                width: 92px;
                height: 168px;
                border: 1px solid black;
                margin-right: 17px;

                opacity: 0.9;

                .cover {
                    width: 92px;
                    height: 168px;
                }

                .card {
                    position: absolute;
                    left: 0;
                    top: 95px;
                    width: 70px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    background: linear-gradient(
                                    270deg,
                                    rgba(177, 12, 126, 1) 0%,
                                    rgba(230, 120, 57, 1) 100%
                    );
                    border-radius: 0 15px 15px 0;

                    font-size: 12px;
                    color: white;
                    cursor: pointer;
                }

                .result {
                    position: absolute;
                    left: 5px;
                    top: 135px;
                    height: 30px;

                    img {
                        height: 30px;
                    }
                }

                .tips {
                    position: absolute;
                    vertical-align: top;
                    left: -100px;
                    top: 175px;

                    padding: 0 10px;
                    width: 244px;
                    height: 27px;
                    line-height: 27px;
                    background: rgba(57, 40, 18, 1);

                    color: white;
                    font-size: 12px;

                    img {
                        vertical-align: baseline;
                        height: 12px;
                    }
                }
            }

            .hover {
                opacity: 1;
                border: 1px solid #f1d7a2;
                box-shadow: 0px 0px 16px 0px rgba(151, 102, 5, 0.82);
            }
        }

        .bottom {
            position: absolute;
            bottom: 0;
            width: 1100px;
            height: 90px;

            background: #212121;

            .guide-button {
                vertical-align: top;
                display: inline-block;
                text-align: center;
                width: 100px;
                cursor: pointer;

                img {
                    padding-top: 15px;
                    padding-bottom: 10px;
                    height: 30px;
                }

                div {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(154, 154, 154, 1);
                    line-height: 20px;
                }
            }

            .reward-button {
                vertical-align: top;
                display: inline-block;
                text-align: center;
                width: 100px;
                cursor: pointer;

                img {
                    padding-top: 15px;
                    padding-bottom: 10px;
                    height: 30px;
                }

                div {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(154, 154, 154, 1);
                    line-height: 20px;
                }
            }

            .ranking-button {
                vertical-align: top;
                display: inline-block;
                text-align: center;
                width: 100px;
                cursor: pointer;

                div.my-ranking {
                    padding-top: 15px;
                    padding-bottom: 10px;
                    height: 34px;
                    line-height: 34px;
                    font-size: 34px;
                    font-family: "DINMedium";
                    color: #d5b578;
                }

                div {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(154, 154, 154, 1);
                    line-height: 20px;
                }
            }

            .split {
                display: inline-block;
                width: 1px;
                height: 90px;
                background: rgba(68, 68, 68, 1);
            }

            .resource {
                vertical-align: top;
                display: inline-block;
                width: 41px;

                margin-left: 30px;
                margin-top: 10px;

                img {
                    width: 41px;
                }

                div {
                    text-align: center;
                    height: 18px;
                    font-size: 18px;
                    font-family: "DINMedium";
                    color: rgba(213, 181, 120, 1);
                    line-height: 22px;
                }
            }

            .play-button {
                vertical-align: top;
                display: inline-block;
                width: 212px;
                margin: 16px 0;
                margin-left: 70px;
                cursor: pointer;

                width: 212px;
                height: 58px;

                width: 212px;
                height: 58px;

                background-image: url("/images/game/play.png");
                background-repeat: no-repeat;
                background-size: contain;
                //   img {
                //     margin: 16px 0;
                //     width: 212px;
                //   }
            }

            .play-button:hover {
                box-shadow: 0px 2px 27px 7px rgba(250, 100, 0, 0.43);
                //   background-image: url(/images/game/play-hover.png);
            }
        }
    }
</style>